import { PrintDoc } from '../print/PrintDoc';
import { fmt } from '../shared/badges';
import { attribuerNumero } from '../../lib/souches';

// Bon de sortie d'huile : traçabilité d'un retrait client (prestation stockée en cuve).
// Numéro de souche dédié BS-2026-XXXX, conservé à la réimpression.
export const BonSortieHuile = ({ retrait, onClose }) => (
  <PrintDoc
    type="Bon de sortie d’huile"
    format="a5"
    numero={attribuerNumero('bon_sortie', retrait.id)}
    date={retrait.date}
    tiers={retrait.client}
    lignes={[
      ['Nature de l’opération', 'Retrait d’huile en dépôt (prestation)'],
      ['Référence retrait', retrait.id],
      ['Cuve de prélèvement', retrait.cuveNom ?? '—'],
      ['Qualité', retrait.qualite ?? '—'],
      ['Quantité retirée', `${fmt(retrait.litres, 1)} kg`],
      ['Solde restant au compte client', `${fmt(retrait.solde, 1)} kg`],
      ...(retrait.notes ? [['Observations', retrait.notes]] : []),
    ]}
    totaux={[]}
    mentions="Sortie de stock sans facturation : l’huile retirée appartient au client. Le solde restant est conservé en cuve à l’huilerie."
    signatures={['Signature du client', 'Signature du magasinier']}
    onClose={onClose}
  />
);
